var render, staticRenderFns
import script from "./TaxChart.vue?vue&type=script&lang=js&"
export * from "./TaxChart.vue?vue&type=script&lang=js&"
import style0 from "./TaxChart.vue?vue&type=style&index=0&id=10117454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10117454",
  null
  
)

export default component.exports